/**
 * Every id the services hand out is a UUID (the catalogue's postings,
 * envoy's applications, the resume service's uploads and exports). An id
 * read from the address is checked before any request is built from it:
 * anything else is a posting there is no such thing as, said at once,
 * rather than four requests that each come back refused.
 */
const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function isUuid(value: string | null | undefined): value is string {
    return typeof value === "string" && UUID.test(value);
}
